import React, { useRef } from 'react';
import GxForm from '../../gx/GxForm';
import { useTranslation } from '../../hx/useTranslation';
import { useNav } from '../../hx/useNav';
import CxHidden from '../../cx/CxHidden';
import CxInput from '../../cx/CxInput';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import { StoreSettComm } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';


const MxSettCommForm = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navBack }] = useNav();

  let r_form = React.useRef(null);

  const [storeSettComm, setStoreSettComm] = useSessionStorage('StoreSettComm', StoreSettComm);

  const formLoad = async (data) => {
    if (data===null) { //nuevo registro
    }
  }
  const formSave = async (lastSaveRv) => {
    if (lastSaveRv.theStatus==='error') {
    } else {
      storeSettComm.itComm = lastSaveRv.theValue;
      Promise.all([setStoreSettComm(storeSettComm)]).then((result) => {
        navBack();
      });
    }
  }
  const formDelete = async (rv) => {
  }

  return (
    <div>
      <GxForm 
        moduleName={`${trans('field.type')} - ${trans('field.comm')}`}
        xref={r_form}
        url="sett/comm" 
        filterIdField='itComm'
        filterIdValue={storeSettComm.itComm} 
        onFormLoad={formLoad} 
        onFormSave={formSave} 
        saveAndExit
        onFormDelete={formDelete} 
        >
        <CxHidden xref={useRef(null)} dbfield="t_comm.itComm" value={storeSettComm.itComm || ''} />
        <CxInput xref={useRef(null)} label={`${trans('field.type')} - ${trans('field.comm')}`} dbfield="t_comm.txTypeComm" required />
        
      </GxForm>

    </div>
  );

}

export default MxSettCommForm;
